/**
 * Collection Products — Client-side Pagination
 * Handles initial page display and pagination controls for the JS-paginated grid.
 * Works across all 3 rendering paths (consumer, professional, standard).
 */
const initCollectionPagination = () => {
  const grid = document.getElementById('js-paginated-grid');
  const navContainer = document.getElementById('js-pagination-nav');
  if (!grid || !navContainer) return;

  const items = [...grid.querySelectorAll('.js-paginated-item')];
  const perPage = parseInt(grid.getAttribute('data-per-page') || '12', 10);
  const totalItems = items.length;
  const totalPages = Math.ceil(totalItems / perPage);

  const params = new URLSearchParams(window.location.search);
  let currentPage = parseInt(params.get('p') || '1', 10);
  if (currentPage < 1) currentPage = 1;
  if (currentPage > totalPages) currentPage = totalPages;

  const start = (currentPage - 1) * perPage;
  const end = start + perPage;

  items.forEach((item, index) => {
    item.style.display = (index >= start && index < end) ? '' : 'none';
  });

  if (totalPages > 1) {
    const prevArrow = currentPage > 1
      ? `<a href="?p=${currentPage - 1}" class="pagination__link pagination__link--arrow">‹</a>`
      : `<span class="pagination__link pagination__link--arrow pagination__link--disabled" aria-disabled="true">‹</span>`;

    const nextArrow = currentPage < totalPages
      ? `<a href="?p=${currentPage + 1}" class="pagination__link pagination__link--arrow">›</a>`
      : `<span class="pagination__link pagination__link--arrow pagination__link--disabled" aria-disabled="true">›</span>`;

    const pageLinks = Array.from({ length: totalPages }, (_, i) => {
      const page = i + 1;
      const link = page === currentPage
        ? `<span class="pagination__link pagination__link--page pagination__link--current" aria-current="page">${page}</span>`
        : `<a href="?p=${page}" class="pagination__link pagination__link--page">${page}</a>`;
      return `<li class="pagination__item">${link}</li>`;
    }).join('');

    navContainer.innerHTML = `
      <nav class="pagination" aria-label="Pagination">
        <ul class="pagination__list" role="list">
          <li class="pagination__item">${prevArrow}</li>
          ${pageLinks}
          <li class="pagination__item">${nextArrow}</li>
        </ul>
      </nav>`;
  }
};

// Ensure DOM is ready before running
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCollectionPagination);
} else {
  initCollectionPagination();
}
